
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e32b7322&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OrderRatings.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrderRatings.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e32b7322!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrderRatings.vue"),
  /* scopeId */
  "data-v-e32b7322",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/Views/OrderRatings.vue
// module id = 338
// module chunks = 1